import { useState } from "react"
import { Head, router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { ArrowLeft } from "lucide-react"
import logo from "@/assets/logo-25segundos-horizontal.png"

interface Props {
  flash?: {
    notice?: string
    alert?: string
  }
  errors?: {
    email?: string[]
  }
}

export default function ForgotPassword({ flash, errors }: Props) {
  const [email, setEmail] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    router.post("/esqueci-senha", { email }, {
      onFinish: () => setIsLoading(false)
    })
  }

  return (
    <>
      <Head title="Esqueci minha senha - Orientação Profissional" />

      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="space-y-4">
            <div className="flex justify-center">
              <img src={logo} alt="25Segundos" className="h-16" />
            </div>
            <div>
              <CardTitle className="text-2xl text-center">Recuperar senha</CardTitle>
              <p className="text-center text-muted-foreground mt-2">
                Digite seu email e enviaremos um link para redefinir sua senha
              </p>
            </div>
          </CardHeader>

          <CardContent>
            {flash?.notice && (
              <div className="mb-4 p-4 bg-green-100 text-green-800 rounded-lg text-sm">
                {flash.notice}
              </div>
            )}

            {flash?.alert && (
              <div className="mb-4 p-4 bg-red-100 text-red-800 rounded-lg text-sm">
                {flash.alert}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
                {errors?.email && (
                  <p className="text-sm text-red-500">{errors.email[0]}</p>
                )}
              </div>

              <Button
                type="submit"
                className="w-full bg-gradient-primary hover:opacity-90 transition-opacity"
                disabled={isLoading}
              >
                {isLoading ? "Enviando..." : "Enviar link de recuperacao"}
              </Button>

              <Button
                type="button"
                variant="ghost"
                className="w-full text-sm"
                onClick={() => router.visit("/login")}
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Voltar para login
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}
